module.exports = __webpack_public_path__ + "img/icons-information.aa0f591c.svg";